export const trackPath = (path: string) => window.analytics.page({ url: path })
